import React from "react";
import { useNavigate } from "react-router-dom";
import "./Integration.css";

function Integration() {
  const navigate = useNavigate();

  const handleCardClick = (platform) => {
    switch (platform) {
      case "facebook":
        // Redirect to Facebook lead fetching page
        navigate("/facebook");
        break;
      case "linkedin":
        // Redirect to LinkedIn connection page (adjust as needed)
        navigate("/linkedin");
        break;
      case "whatsapp":
        // Redirect to WhatsApp connection page (adjust as needed)
        navigate("/whatsapp");
        break;
      case "twitter":
        // Redirect to Twitter connection page (adjust as needed)
        navigate("/twitter");
        break;
      default:
        break;
    }
  };

  return (
    <div className="connect-page">
      <h1 className="connect-title">Connect Your Accounts</h1>
      <div className="card-container">
        <div className="card" onClick={() => handleCardClick("facebook")}>
          <img src="/img/facebook.png" alt="Facebook" className="card-icon" />
          <h2>Connect Facebook</h2>
        </div>
        <div className="card" onClick={() => handleCardClick("linkedin")}>
          <img src="/img/linkedin.png" alt="LinkedIn" className="card-icon" />
          <h2>Connect LinkedIn</h2>
        </div>
        <div className="card" onClick={() => handleCardClick("whatsapp")}>
          <img src="/img/whatsapp.png" alt="WhatsApp" className="card-icon" />
          <h2>Connect WhatsApp</h2>
        </div>
        <div className="card" onClick={() => handleCardClick("twitter")}>
          <img src="/img/twitter.png" alt="Twitter" className="card-icon" />
          <h2>Connect Twitter</h2>
        </div>
      </div>
    </div>
  );
}

export default Integration;
